export default {
  organizations: 'mdi mdi-city',
  projects: 'mdi mdi-briefcase',
  teams: 'mdi mdi-account-multiple',
  users: 'mdi mdi-account',
}
